import styles from './BannerModule.module.scss';

import type { BannerAssembly } from 'api/contentful/contentTypes.cloverdotcom';
import cx from 'classnames';
import { ButtonLinkV2 } from 'components/Button/ButtonLinkV2';
import { RichBlurb } from 'components/RichBlurb/RichBlurb';
import type { Entry } from 'contentful';
import * as React from 'react';
import { flattenContentfulData } from 'services/cms/flattenContentful';
import { getField } from 'utils/EntryUtil';
import { FadeToastUp } from '../Animation/FadeToastUp/FadeToastUp';
import { Blurb } from '../Contentful/Blurb';
import { Text } from '../Contentful/Text';

export const COOKIE_BANNER_COOKIE_NAME = 'cookieConsentSeen';

export interface IBannerProps extends React.AllHTMLAttributes<HTMLElement> {
  entry?: Entry<BannerAssembly>;
  button?: React.ReactNode;
  tagName: keyof React.ReactHTML;
  notCentered?: boolean;
  backgroundYellow?: boolean;
}

export class BannerModule extends React.PureComponent<IBannerProps> {
  static defaultProps = {
    tagName: 'div' as keyof React.ReactHTML,
  };

  render() {
    const { tagName, entry, button, className, notCentered, backgroundYellow, ...otherProps } = this.props;

    if (!entry || !entry.fields) {
      return null;
    }

    const { topic } = entry.fields;

    if (!topic || !topic.fields) {
      return null;
    }

    const { link } = topic.fields;

    return (
      <FadeToastUp>
        {React.createElement(
          tagName,
          {
            className: cx(styles.bannerWrapper, className, {
              [styles.bannerWrapperNotCentered]: notCentered,
              [styles.bannerWrapperYellowHighlight]: backgroundYellow,
            }),
            ...otherProps,
          },
          <div className={cx(styles.banner)}>
            <div className={styles.textWrapper}>
              <Text tagName="strong" entry={topic} field="title" />
              <Blurb entry={topic} field="blurb" />
              <RichBlurb document={getField(topic, 'richBlurb')} />
            </div>
            {button || (
              <ButtonLinkV2 entry={flattenContentfulData(link)} className={cx(styles.button)} isButton />
            )}
          </div>,
        )}
      </FadeToastUp>
    );
  }
}
